module.exports = __webpack_public_path__ + "ef78e6e06783b3ef7e82636133d3ba01.svg";